// Libraries
import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getAllSchedules = async (partnerId, serviceId, petBreedId, petTemperamentId, date, professionalId) => {
  const professional = professionalId || ''
  const { data } = await Axios({
    baseURL: envConfig.partner,
    url: `/professionals/times/${partnerId}/${serviceId}/${petBreedId}/${petTemperamentId}/${date}?professional_id=${professional}`,
    withCredentials: true
  })
  return data
}

export const getNames = async ids => {
  const { data } = await Axios({
    baseURL: envConfig.partner,
    url: '/professionals/name',
    params: {
      ids
    },
    withCredentials: true
  })
  return data
}
